import { BankIdStatusEnum } from '@app/enums/bankid-status.enum';

export const BankIdStatusList = [
    {
        value: null,
        label: 'Čeká na ověření',
    },
    {
        value: undefined,
        label: 'Čeká na ověření',
    },
    {
        value: BankIdStatusEnum.waiting,
        label: 'Čeká na ověření',
    },
    {
        value: BankIdStatusEnum.verified,
        label: 'Ověřeno',
    },
];
